import { render, staticRenderFns } from "./EditLanguage.vue?vue&type=template&id=d476aa2a&scoped=true&"
import script from "./EditLanguage.vue?vue&type=script&lang=js&"
export * from "./EditLanguage.vue?vue&type=script&lang=js&"
import style0 from "./EditLanguage.vue?vue&type=style&index=0&id=d476aa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d476aa2a",
  null
  
)

export default component.exports